// Beispielhafter Gebrauch von useState in DataRequestForm.js
import React, { useState } from 'react';





const DataRequestForm = () => {
    const [formData, setFormData] = useState({
        // Initialwerte für das Formular setzen
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    return (
        <form>
            {/* Formularfelder hier, mit onChange={handleChange} */}
        </form>
    );
};

export default DataRequestForm; // Stellen Sie sicher, dass diese Zeile existiert
